"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCALIZATION_FALLBACK = exports.SEARCH_STRING_LOCALIZATION_KEY = exports.COOKIE_USER_CULTURE_KEY = exports.languages = void 0;
exports.languages = {
    'en-us': 'en',
    'de-de': 'de',
    'es-es': 'es',
    'es-mx': 'es-MX',
    'fr-fr': 'fr',
    'it-it': 'it',
    'pt-br': 'pt-BR',
    'ru-ru': 'ru',
    'zh-hans': 'zh-Hans',
    'zh-hant': 'zh-Hant',
    'ja-jp': 'ja',
};
exports.COOKIE_USER_CULTURE_KEY = '_UserCulture';
exports.SEARCH_STRING_LOCALIZATION_KEY = 'locale';
exports.LOCALIZATION_FALLBACK = 'en-us';
